import { useCallback } from "react";
import {
  getLinkedInspections,
  GetLinkedInspectionsParams,
  LinkedInspection,
} from "../../api/WorkOrders";
import { useWorkOrderStore } from "../../store/wo-order";

const parseWorkOrderComponents = (workOrderNumber: string) => {
  const parts = workOrderNumber.split("-");
  if (parts.length === 1) {
    return {
      base: workOrderNumber,
      task: "  ",
      subtask: "  ",
    };
  }
  const filteredParts = parts.filter((part) => part.trim() !== "");
  const result = {
    base: filteredParts[0] || "",
    task: filteredParts[1] || "  ",
    subtask: filteredParts[2] || "  ",
  };
  return result;
};

export default function useGetLinkedInspection() {
  const setLinkedInspectionsForWo = useWorkOrderStore(
    (state) => state.setLinkedInspectionsForWo
  );

  const getLinkedInspection = useCallback(
    async (woNumber: string) => {
      const { base, task, subtask } = parseWorkOrderComponents(woNumber);
      if (!base) {
        throw new Error("Invalid work order number format");
      }
      // Load inspections
      const params: GetLinkedInspectionsParams = {
        WoBase: base,
        WoTask: task,
        WoSubtask: subtask,
      };

      const linkedResponse = await getLinkedInspections(params);
      let linkedInspections: LinkedInspection[] = [];
      if (!linkedResponse.isError) {
        linkedInspections = linkedResponse.data ?? [];
      }
      setLinkedInspectionsForWo(woNumber, linkedInspections);
    },
    [setLinkedInspectionsForWo]
  );

  return { getLinkedInspection };
}
